import { Dispatch, useCallback, useEffect, useState } from 'react'

import { ClickEvent } from '@web/types'

type Props = {
  tooltipKey: string
  maxShowCount: number
  isShowable?: boolean
}
type UseShowTooltip = {
  showTooltipLayer: boolean
  setShowTooltipLayer: Dispatch<React.SetStateAction<boolean>>
  closeTooltip: (e?: any) => void
  handleShowTooltip: () => void
}

const useShowTooltip = ({ tooltipKey, maxShowCount, isShowable = true }: Props): UseShowTooltip => {
  const [showTooltipLayer, setShowTooltipLayer] = useState(false)

  const getShowTooltipCount = (key: string) => {
    return parseInt(localStorage.getItem(key) ?? '0')
  }

  const saveShowTooltipCount = (key: string, count: number) => {
    localStorage.setItem(key, count.toString())
  }

  const closeTooltip = (e?: ClickEvent) => {
    e?.stopPropagation?.()
    setShowTooltipLayer(false)
  }

  const handleShowTooltip = useCallback(
    (e?: ClickEvent) => {
      e?.stopPropagation()

      const showedCount = getShowTooltipCount(tooltipKey)
      if (showedCount < maxShowCount && isShowable) {
        setShowTooltipLayer(true)
        saveShowTooltipCount(tooltipKey, showedCount + 1)
      } else {
        closeTooltip()
      }
    },
    [tooltipKey, maxShowCount, isShowable],
  )

  useEffect(() => {
    handleShowTooltip()
  }, [handleShowTooltip])

  return { showTooltipLayer, setShowTooltipLayer, closeTooltip, handleShowTooltip }
}

export default useShowTooltip
